<template>
  <div class="report-container">
    <div class="subheader">
      <main-button flat @click="goBack">
        <v-icon class="arrow-back">arrow_back</v-icon>
        {{ adminText('organizationAll.back_61bb8d29', 'back') }}
      </main-button>
      <div
        v-if="!$apollo.loading"
        class="export-button"
        @click="showReportsExportModal = !showReportsExportModal"
      >
        <span class="export-text">{{ adminText('organizationAll.export_51713409', 'export') }}</span>
        <img src="/assets/download.svg" :alt="adminText('organizationAll.download_icon_421b8552', 'Download icon')" style="width: 1.5rem; height: 1.5rem">
      </div>
    </div>
    <div class="table-header">
      <h1 class="subs-title">{{ adminText('organizationAll.live_report_2dca02e3', 'Live Report') }}</h1>
      <v-text-field
        :label="adminText('organizationAll.search_events_f3e47cc3', 'Search Events')"
        append-icon="search"
        box
        style="min-width: 18rem"
        @change="handleSearchChange($event)"
      />
      <div class="filter-dates-container">
        <date-field v-model="dateStart" style="width: 100%" :label="adminText('organizationAll.start_date_9d7ab1a5', 'Start Date')" :max="dateEnd" />
        <date-field v-model="dateEnd" style="width: 100%" :label="adminText('organizationAll.end_date_84b14781', 'End Date')" :min="dateStart" />
      </div>
    </div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div class="table-container">
      <table id="data-table">
        <thead>
          <tr>
            <th class="fixed-td fixed-hd left-top-td">{{ adminText('organizationAll.event_name_8e10d77c', 'Event name') }}</th>
            <th class="fixed-td-desktop fixed-hd-desktop left-top-td" style="left: 200px">
              {{ adminText('organizationAll.date_and_time_07c9c3a5', 'Date and time') }}
            </th>
            <th class="fixed-hd">{{ adminText('organizationAll.location_d219c681', 'Location') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.venue_capacity_e9b53f8a', 'Venue Capacity') }}</th>
            <th class="fixed-hd">{{ adminText('organizationAll.total_tickets_2ac4c693', 'Total Tickets') }}</th>
            <th class="fixed-hd">{{ adminText('organizationAll.available_7c62a142', 'Available') }}</th>
            <th class="fixed-hd">{{ adminText('organizationAll.sold_e6560d9c', 'Sold') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.promo_code_edfcc5e3', 'Promo code') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.average_price_205bddeb', 'Average price') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.number_of_transactions_b6109e40', 'Number of transactions') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.total_occupancy_e242d561', 'Total Occupancy') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.revenue_35cf82f9', 'Revenue') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in events" :key="event.id">
            <td class="fixed-td">{{ event.title }}</td>
            <td class="fixed-td-desktop" style="left: 200px">{{ formatDate(event.from) }}</td>
            <td>{{ getLocation(event) }}</td>
            <td class="tr-right-border">{{ event.audienceCapacity }}</td>
            <td>{{ event.audienceCapacity }}</td>
            <td>{{ event.audienceCapacity - event.report.totalSoldCount }}</td>
            <td>{{ event.report.totalSoldCount }}</td>
            <td class="tr-right-border">{{ event.report.totalWithPromoCode }}</td>
            <td class="tr-right-border">{{ event.report.averagePrice }} €</td>
            <td class="tr-right-border">{{ event.report.totalOrderCount }}</td>
            <td class="tr-right-border">{{ event.report.totalOccupancy }}</td>
            <td class="tr-right-border">
              {{ event.report.totalSoldOnlineAmount + event.report.totalSoldOfflineAmount }} €
            </td>
          </tr>
        </tbody>
        <tfoot />
      </table>
    </div>
    <div
      v-if="recapitulationData && recapitulationData.eventAmount > 0"
      class="table-container-recapitulation"
    >
      <table>
        <thead>
          <tr>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.event_amount_89bf5794', 'Event amount') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.capacity_45bd908d', 'Capacity') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.total_tickets_2ac4c693', 'Total Tickets') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.available_7c62a142', 'Available') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.sold_e6560d9c', 'Sold') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.promo_code_edfcc5e3', 'Promo code') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.average_price_205bddeb', 'Average price') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.number_of_transactions_b6109e40', 'Number of transactions') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.total_occupancy_20017422', 'Total occupancy') }}</th>
            <th class="fixed-hd tr-right-border">{{ adminText('organizationAll.total_revenue_1a21e656', 'Total revenue') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tr-right-border">{{ recapitulationData.eventAmount }}</td>
            <td class="tr-right-border">{{ recapitulationData.capacity }}</td>
            <td class="tr-right-border">{{ recapitulationData.totalTickets }}</td>
            <td class="tr-right-border">{{ recapitulationData.available }}</td>
            <td class="tr-right-border">{{ recapitulationData.sold }}</td>
            <td class="tr-right-border">{{ recapitulationData.promoCode }}</td>
            <td class="tr-right-border">
              {{
                recapitulationData.sumAveragePrice === 0
                  ? '/'
                  : (
                    recapitulationData.sumAveragePrice /
                    (recapitulationData.eventAmount === 0 ? 1 : recapitulationData.eventAmount)
                  ).toFixed(2)
              }}
              €
            </td>
            <td class="tr-right-border">{{ recapitulationData.numberOfTransactions }}</td>
            <td class="tr-right-border">
              {{
                recapitulationData.sumTotalOccupancy === 0
                  ? '/'
                  : (
                    recapitulationData.sumTotalOccupancy /
                    (recapitulationData.eventAmount === 0 ? 1 : recapitulationData.eventAmount)
                  ).toFixed(2)
              }}
              %
            </td>
            <td class="tr-right-border">{{ recapitulationData.totalRevenue.toFixed(2) }} €</td>
          </tr>
        </tbody>
      </table>
    </div>
    <reports-export-modal
      v-if="showReportsExportModal"
      @handleExcelExport="handleExcelExport"
      @handleCsvExport="handleCsvExport"
      @close="showReportsExportModal = !showReportsExportModal"
    />
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { GET_EVENTS_REPORTS } from '@/graphql/event.graphql'
import { OrganizationType } from '@/types'
import moment from 'moment'
import { round } from 'mathjs'
import ReportsExportModal from '@/components/organizations/reports/ReportsExportModal.vue'
import * as XLSX from 'xlsx'

export default {
  mixins: [OrganizationLocalization],
  name: 'organization-reports-container',
  components: { ReportsExportModal },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      OrganizationType,
      events: [],
      showReportsExportModal: false,
      displayCustomFrom: true,
      displayCustomTo: true,
      searchTerm: null,
      dateStart: null,
      dateEnd: null,
      recapitulationData: null,
    }
  },
  methods: {
    formatDate(createdAt) {
      return moment(createdAt).format('DD.MM.YYYY HH:mm')
    },
    getLocation(event) {
      if (event.venue) {
        return event.venue.city || ''
      } else if (event.location) {
        return event.location.city || ''
      }

      return ''
    },
    countPurchases(orders) {
      if (orders) {
        return orders.reduce((acc, item) => {
          return acc + item.purchases.length
        }, 0)
      }

      return ''
    },
    sortEvents(eventList) {
      return eventList.sort((event1, event2) => new Date(event1.from) - new Date(event2.from))
    },
    modifyEventsData(events, getEventsReport) {
      this.recapitulationData = {
        eventAmount: 0,
        capacity: 0,
        totalTickets: 0,
        available: 0,
        sold: 0,
        promoCode: 0,
        sumAveragePrice: 0,
        numberOfTransactions: 0,
        sumTotalOccupancy: 0,
        totalRevenue: 0,
      }
      for (const event of events) {
        const report = getEventsReport.reports[event.id]
        if (!report) {
          continue
        }
        let totalSoldOnlineAmount = 0
        let totalSoldOnlineCount = 0
        let totalSoldOfflineCount = 0
        let totalSoldOfflineAmount = 0
        let totalWithPromoCode = 0
        let totalOrderCount = 0
        for (const r of report) {
          if (parseInt(r.offline) > 0) {
            totalSoldOfflineCount += parseInt(r.offline)
            totalSoldOfflineAmount += parseFloat(r.total)
          } else {
            totalSoldOnlineCount += parseInt(r.online)
            totalSoldOnlineAmount += parseFloat(r.total)
          }
          if (r.promocode) {
            totalWithPromoCode += parseInt(r.online) + parseInt(r.offline)
          }
          totalOrderCount += parseInt(r.orderCount) || 0
        }

        const totalSoldCount = totalSoldOfflineCount + totalSoldOnlineCount
        const totalSoldAmount = totalSoldOfflineAmount + totalSoldOnlineAmount
        event.audienceCapacity = Math.max(event.audienceCapacity || 0, totalSoldCount)
        event.report = {
          totalWithPromoCode,
          totalSoldCount,
          totalSoldAmount,
          totalSoldOfflineCount,
          totalSoldOfflineAmount,
          totalOrderCount,
          totalOccupancy:
            round(
              100 - ((event.audienceCapacity - totalSoldCount) * 100) / event.audienceCapacity,
              2,
            ) + ' %',
          totalSoldOnlineCount,
          averagePrice: round(totalSoldAmount / totalSoldCount, 2) || '/',
          totalSoldOnlineAmount,
        }

        ++this.recapitulationData.eventAmount
        this.recapitulationData.capacity += event.audienceCapacity
        this.recapitulationData.totalTickets += event.audienceCapacity
        this.recapitulationData.available += event.audienceCapacity - event.report.totalSoldCount
        this.recapitulationData.sold += event.report.totalSoldCount
        this.recapitulationData.promoCode += event.report.totalWithPromoCode
        this.recapitulationData.sumAveragePrice += round(totalSoldAmount / totalSoldCount, 2) || 0
        this.recapitulationData.numberOfTransactions += event.report.totalOrderCount
        this.recapitulationData.sumTotalOccupancy +=
          round(
            100 - ((event.audienceCapacity - totalSoldCount) * 100) / event.audienceCapacity,
            2,
          ) || 0
        this.recapitulationData.totalRevenue +=
          event.report.totalSoldOnlineAmount + event.report.totalSoldOfflineAmount
      }
    },
    handleExcelExport() {
      const table = document.getElementById('data-table')
      const ws = XLSX.utils.table_to_sheet(table, { raw: true })
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, 'exported_reports.xlsx')
    },
    handleCsvExport() {
      const table = document.getElementById('data-table')
      const ws = XLSX.utils.table_to_sheet(table, { raw: true })
      const csv = XLSX.utils.sheet_to_csv(ws)
      const csvData = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      if (link.download !== undefined) {
        const url = URL.createObjectURL(csvData)
        link.setAttribute('href', url)
        link.setAttribute('download', 'exported_reports.csv')
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    async handleSearchChange(input) {
      this.searchTerm = input
      await this.$apollo.queries.getEventsReport.refetch()
    },
  },
  apollo: {
    getEvents: {
      query: GET_EVENTS_REPORTS,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          searchTerm: this.searchTerm,
          from: this.dateStart,
          to: this.dateEnd,
        }
      },
      manual: true,
      result({ data: { getEventsReport }, loading }) {
        if (loading) {
          return
        }
        this.events = this.sortEvents(getEventsReport.events)
        this.modifyEventsData(this.events, getEventsReport)
      },
    },
  },
}
</script>

<style scoped>
.subheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.table-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  @media screen and (max-width: 537px) {
    justify-content: flex-start;
  }
}

.filter-dates-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  flex: 1 0 0;
  min-width: 18rem;
}

tr {
  border: 1px solid var(--Grey-30, #d9d9d9);
  background: white;
}
.tr-right-border {
  border-right: 1px solid var(--Grey-30, #d9d9d9);
}
td {
  text-align: center;
  margin: 0;
  padding: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 170px;
}

td:first-child {
  text-align: center;
}

th {
  margin: 0;
  padding: 1rem;
  width: 170px;
}

tbody {
  border: 1px solid var(--grey-40, #f5f5f5);
}

th:first-child {
  border-radius: 0.5rem 0 0 0;
}

th:last-child {
  border-radius: 0 0.5rem 0 0;
}

table {
  table-layout: fixed;
  width: 100%;
  overflow-x: scroll;
  border-collapse: collapse;
}

.fixed-td {
  position: sticky;
  width: 200px;
  z-index: 2;
  left: 0;
  background-color: #fff;
}
.fixed-hd {
  position: sticky;
  top: 0;
  z-index: 1;
}
@media screen and (min-width: 1100px) {
  .fixed-td-desktop {
    position: sticky;
    width: 200px;
    z-index: 2;
    left: 0;
    background-color: #fff;
  }
  .fixed-hd-desktop {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}
.left-top-td {
  z-index: 3;
}

tfoot {
  height: 2rem;
  border: 1px solid var(--grey-40, #f5f5f5);
}

.report-container {
  padding: 0 !important;
  margin: 0 1.5rem !important;
  display: flex;
  flex-direction: column;
  font-size: 1rem !important;
  /* max-width: 43.75rem; */
}

.table-container {
  overflow: auto;
}

.table-container-recapitulation {
  overflow: auto;
  margin-top: 2rem;
}

.subs-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.export-button {
  display: flex;
  height: 3rem;
  padding: 0.75rem 1.25rem 0.75rem 1.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 1.5rem;
  background: #0277bd;
  margin-bottom: 22px;
}

.export-button:hover {
  cursor: pointer;
}

.export-text {
  color: #fff;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Raleway;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.01688rem;
  text-transform: uppercase;
}
</style>
